export default __webpack_public_path__ + "static/media/608.14f2a5fa.jpg";